import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";

interface SubqueriesSentimentTooltipProps {
  rootSentimentPositive: number;
  rootSentimentNeutral: number;
  rootSentimentNegative: number;

  rowSentimentPositive: number;
  rowSentimentNeutral: number;
  rowSentimentNegative: number;
}

export default function SubqueriesSentimentTooltip(props: SubqueriesSentimentTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const {
    rootSentimentPositive, rootSentimentNeutral, rootSentimentNegative,
    rowSentimentPositive, rowSentimentNeutral, rowSentimentNegative,
  }: SubqueriesSentimentTooltipProps = props;

  const positivePct = rowSentimentPositive / (rootSentimentPositive || 1) || 0;
  const neutralPct = rowSentimentNeutral / (rootSentimentNeutral || 1) || 0;
  const negativePct = rowSentimentNegative / (rootSentimentNegative || 1) || 0;

  return (
    <Box>
      <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold" }}>
        {i18n.t("sentiment")}
      </Typography>
      <Box sx={{ display: "grid", width: "100%", gridTemplateColumns: "auto auto auto auto", gap: "3px 10px", textAlign: "right", alignItems: "bottom" }}>
        <Box sx={{ gridColumn: "span 2" }}>{i18n.t("widget-types.subqueries.subquery")}</Box>
        <Box>{i18n.t("widget-types.subqueries.original")}</Box>
        <Box>%</Box>

        <Box sx={{ color: theme.colors.namedColors.positive}}>
          <Typography variant="body2">
            {i18n.t("positive")}
          </Typography>
        </Box>
        <Box>
          <ISONumber number={rowSentimentPositive} sx={{  color: theme.colors.namedColors.positive, fontWeight: "bold" }}/>
        </Box>
        <Box>
          <ISONumber number={rootSentimentPositive} sx={{ fontWeight: "bold", color: theme.colors.namedColors.positive }}/>
        </Box>
        <Box>
          <ISOPercentage hideTooltip={true} value={positivePct} sx={{ color: theme.palette.primary.main, paddingBottom: "1px" }}/>
        </Box>

        <Box sx={{ color: theme.colors.namedColors.neutral }}>
          <Typography variant="body2">
            {i18n.t("neutral")}
          </Typography>
        </Box>
        <Box>
          <ISONumber number={rowSentimentNeutral} sx={{ fontWeight: "bold", color: theme.colors.namedColors.neutral }}/>
        </Box>
        <Box>
          <ISONumber number={rootSentimentNeutral} sx={{ fontWeight: "bold", color: theme.colors.namedColors.neutral }}/>
        </Box>
        <Box>
          <ISOPercentage hideTooltip={true} value={neutralPct} sx={{ color: theme.palette.primary.main, paddingBottom: "1px" }}/>
        </Box>

        <Box sx={{ color: theme.colors.namedColors.negative }}>
          <Typography variant="body2">
            {i18n.t("negative")}
          </Typography>
        </Box>
        <Box>
          <ISONumber number={rowSentimentNegative} sx={{ fontWeight: "bold", color: theme.colors.namedColors.negative }}/>
        </Box>
        <Box>
          <ISONumber number={rootSentimentNegative} sx={{ fontWeight: "bold", color: theme.colors.namedColors.negative }}/>
        </Box>
        <Box>
          <ISOPercentage hideTooltip={true} value={negativePct} sx={{ color: theme.palette.primary.main, paddingBottom: "1px" }}/>
        </Box>
      </Box>
    </Box>
  );
}